// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vet-breadcrumb[data-v-433dcea8]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:.75rem 1rem;margin-bottom:1rem;list-style:none;background-color:#e9ecef;border-radius:.25rem}.vet-breadcrumb .item[data-v-433dcea8]:not(:first-child):before{content:\">\";color:#6c757d;padding-left:.6rem;padding-right:.2rem}.vet-breadcrumb .item.active[data-v-433dcea8]{color:#6c757d}", ""]);
// Exports
module.exports = exports;
